import React from "react";
import { Navigate } from "react-router-dom";
import Main from "./layout/Main";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const profile = localStorage.getItem("userProfile");
  if (token && profile) {
    return <Main>{children}</Main>;
  }
  return <Navigate to="/login" replace />;
};

export default PrivateRoute;